"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMap = void 0;
var react_1 = __importDefault(require("react"));
var api_1 = require("@react-google-maps/api");
var GoogleGeocoding_1 = __importDefault(require("../../constants/GoogleGeocoding"));
var i18n_1 = __importDefault(require("../../i18n"));
var Map_1 = __importDefault(require("./Map"));
var PostMap = function (_a) {
    var marker = _a.marker;
    var isLoaded = api_1.useJsApiLoader({
        googleMapsApiKey: GoogleGeocoding_1.default.API_KEY,
        libraries: GoogleGeocoding_1.default.MAP_LIBS,
        language: i18n_1.default.language,
    }).isLoaded;
    return (react_1.default.createElement("div", { className: "post-map" }, isLoaded && react_1.default.createElement(Map_1.default, { marker: marker })));
};
exports.PostMap = PostMap;
